var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSdgIconDe12(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 566.93335,
    height: 566.93335,
    viewBox: "0 0 566.93335 566.93335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,566.93333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4255.07,-2.35938 H 0.945313 V 4252 H 4255.07 V -2.35938",
    style: {
      fill: "#cd8016",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 433.742,3694.18 h 1.289 v -656.63 h 144.215 v 857.76 H 464.004 L 331.246,3739.69 v -150.54 h 1.242 l 101.254,105.03",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 665.219,3718.16 v -103.7 H 796.781 V 3722 c 0,51.85 25.352,67.02 55.657,67.02 27.886,0 51.898,-11.35 51.898,-64.54 v -70.79 c 0,-70.89 -6.301,-98.7 -53.188,-148.03 l -80.91,-86.05 C 691.805,3336.1 662.637,3280.43 662.637,3195.65 V 3037.49 H 1037.19 V 3155.2 H 800.551 v 40.45 c 0,67.08 24.062,92.37 60.722,131.59 l 92.368,97.41 c 74.669,79.7 91.139,130.34 91.139,216.37 v 83.46 c 0,122.77 -59.428,180.93 -188.518,180.93 -126.559,0 -191.043,-67.05 -191.043,-187.25",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3215.75,2045.81 c -187.89,148.4 -436.82,151.45 -527.95,129.76 l -10.59,-2.45 c -105.28,-24.87 -272.52,-66.02 -468.27,-308.93 -1.08,-1.35 -2.21,-2.73 -3.25,-4.13 l -2.48,-3 c -1.91,-2.7 -3.25,-5.88 -3.25,-9.44 0,-2.95 0.72,-5.64 2.12,-8.14 l 4.54,-7.49 c 24.58,-41.1 55.56,-93.99 81.73,-142.73 0.27,-0.52 0.52,-0.91 0.73,-1.5 2.79,-5.39 8.36,-9.19 14.92,-9.19 4.54,0 8.62,1.8 11.56,4.69 1.24,1.61 2.48,3.28 3.57,4.98 173.75,240.29 310.37,273.46 402.8,295.2 l 11.05,2.61 c 47.97,11.51 230.33,10.82 362,-93.13 102.75,-81.11 154.91,-210.19 154.91,-383.61 0,-290.91 -141.48,-404.71 -260.24,-448.93 -183.92,-68.759 -360.3,23.16 -361.59,23.85 l -7.91,3.85 c -101.04,43.87 -251.81,135.13 -393.91,420.54 -286.41,575.22 -525.99,629.39 -684.51,665.3 l -8.47,1.88 c -72.18,16.37 -322.87,27.93 -519.9,-129.34 -102.962,-82.12 -225.594,-241.81 -225.594,-535.99 0,-179.25 36.816,-297.59 131.464,-422.11 20.758,-28.37 232.87,-300.868 642.95,-222.282 65.62,12.57 154.54,43.914 252.33,117.211 l 90.26,-81.43 c 5.88,-5.339 15.28,-4.898 20.7,1.032 2.58,2.769 3.67,6.3 3.61,9.789 v 1.211 l 65.12,400.529 0.05,4.44 c -0.05,3.9 -1.65,7.87 -4.85,10.66 -2.74,2.61 -6.15,3.62 -9.56,3.62 l -2.78,-0.27 -4.24,-0.44 -383.64,-107.39 -6.97,-1.13 c -2.79,-0.6 -5.37,-2.04 -7.33,-4.29 -5.58,-6.09 -5.06,-15.39 1.08,-20.81 l 4.5,-4.16 85.97,-77.63 c -55.51,-35.93 -103.89,-52.43 -140.81,-59.59 -296.69,-56.59 -443.18,137.74 -448.75,145.36 l -2.07,2.84 c -68.93,90.5 -92.214,167.42 -92.214,304.84 0,173.93 51.224,303.07 152.264,383.77 128.32,102.39 305.27,102.99 355.25,91.6 l 8.62,-1.94 c 129.91,-29.41 307.89,-69.65 553.05,-562.11 127.33,-255.66 286.83,-422.829 487.52,-511.001 25.57,-13.027 147.42,-70.809 305.58,-70.809 66.14,0 138.58,10.09 212.89,37.719 116.32,43.422 386.94,191.761 386.94,631.611 0,294 -124.49,454.02 -228.95,536.5",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3215.75,2045.81 c -187.89,148.4 -436.82,151.45 -527.95,129.76 l -10.59,-2.45 c -105.28,-24.87 -272.52,-66.02 -468.27,-308.93 -1.08,-1.35 -2.21,-2.73 -3.25,-4.13 l -2.48,-3 c -1.91,-2.7 -3.25,-5.88 -3.25,-9.44 0,-2.95 0.72,-5.64 2.12,-8.14 l 4.54,-7.49 c 24.58,-41.1 55.56,-93.99 81.73,-142.73 0.27,-0.52 0.52,-0.91 0.73,-1.5 2.79,-5.39 8.36,-9.19 14.92,-9.19 4.54,0 8.62,1.8 11.56,4.69 1.24,1.61 2.48,3.28 3.57,4.98 173.75,240.29 310.37,273.46 402.8,295.2 l 11.05,2.61 c 47.97,11.51 230.33,10.82 362,-93.13 102.75,-81.11 154.91,-210.19 154.91,-383.61 0,-290.91 -141.48,-404.71 -260.24,-448.93 -183.92,-68.759 -360.3,23.16 -361.59,23.85 l -7.91,3.85 c -101.04,43.87 -251.81,135.13 -393.91,420.54 -286.41,575.22 -525.99,629.39 -684.51,665.3 l -8.47,1.88 c -72.18,16.37 -322.87,27.93 -519.9,-129.34 -102.962,-82.12 -225.594,-241.81 -225.594,-535.99 0,-179.25 36.816,-297.59 131.464,-422.11 20.758,-28.37 232.87,-300.868 642.95,-222.282 65.62,12.57 154.54,43.914 252.33,117.211 l 90.26,-81.43 c 5.88,-5.339 15.28,-4.898 20.7,1.032 2.58,2.769 3.67,6.3 3.61,9.789 v 1.211 l 65.12,400.529 0.05,4.44 c -0.05,3.9 -1.65,7.87 -4.85,10.66 -2.74,2.61 -6.15,3.62 -9.56,3.62 l -2.78,-0.27 -4.24,-0.44 -383.64,-107.39 -6.97,-1.13 c -2.79,-0.6 -5.37,-2.04 -7.33,-4.29 -5.58,-6.09 -5.06,-15.39 1.08,-20.81 l 4.5,-4.16 85.97,-77.63 c -55.51,-35.93 -103.89,-52.43 -140.81,-59.59 -296.69,-56.59 -443.18,137.74 -448.75,145.36 l -2.07,2.84 c -68.93,90.5 -92.214,167.42 -92.214,304.84 0,173.93 51.224,303.07 152.264,383.77 128.32,102.39 305.27,102.99 355.25,91.6 l 8.62,-1.94 c 129.91,-29.41 307.89,-69.65 553.05,-562.11 127.33,-255.66 286.83,-422.829 487.52,-511.001 25.57,-13.027 147.42,-70.809 305.58,-70.809 66.14,0 138.58,10.09 212.89,37.719 116.32,43.422 386.94,191.761 386.94,631.611 0,294 -124.49,454.02 -228.95,536.5",
    style: {
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 19.2987,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1426.73,3771.83 v -225.76 h -50.88 v 359.31 h 59.36 l 65.18,-206.15 v 206.15 h 50.35 v -359.31 h -53 l -71.01,225.76",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1648.79,3660.01 h 48.22 l -23.84,144.14 h -0.53 z m -75.78,-113.94 67.83,359.31 h 68.89 l 68.36,-359.31 h -62 l -11.13,65.72 h -64.12 l -10.6,-65.72 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1792.42,3638.81 v 173.82 c 0,56.18 26.5,96.98 90.1,96.98 66.77,0 85.31,-37.1 85.31,-90.09 v -42.39 h -55.11 v 47.16 c 0,22.26 -7.42,34.98 -29.14,34.98 -21.73,0 -30.74,-15.37 -30.74,-37.1 v -192.9 c 0,-21.72 9.01,-37.09 30.74,-37.09 21.72,0 29.14,13.78 29.14,34.97 v 66.25 h 55.11 v -62 c 0,-51.41 -21.19,-89.56 -85.31,-89.56 -63.6,0 -90.1,41.33 -90.1,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2116.77,3704.52 h -58.3 v -158.45 h -60.41 v 359.31 h 60.41 v -152.1 h 58.3 v 152.1 h 60.94 v -359.31 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2328.24,3704.52 h -58.3 v -158.45 h -60.41 v 359.31 h 60.41 v -152.1 h 58.3 v 152.1 h 60.94 v -359.31 h -60.94 v 158.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2487.24,3660.01 h 48.22 l -23.85,144.14 h -0.52 z m -75.78,-113.94 67.83,359.31 h 68.89 l 68.36,-359.31 h -62 l -11.13,65.72 h -64.12 l -10.6,-65.72 h -57.23",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2638.82,3905.38 h 60.42 v -310.02 h 72.07 v -49.29 h -132.49 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2754.89,3905.38 h 160.57 v -49.29 h -49.81 v -310.02 h -60.95 v 310.02 h -49.81 v 49.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2940.92,3905.38 h 60.41 v -359.31 h -60.41 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3124.81,3737.91 h 85.85 v -191.84 h -43.46 v 39.22 c -7.94,-27.02 -24.9,-43.45 -57.76,-43.45 -51.93,0 -75.78,41.33 -75.78,96.97 v 173.82 c 0,56.18 27.03,96.98 90.62,96.98 66.77,0 86.38,-37.1 86.38,-90.09 v -31.79 h -55.12 v 36.56 c 0,22.26 -8.47,34.98 -30.2,34.98 -21.73,0 -31.26,-15.37 -31.26,-37.1 v -192.9 c 0,-21.72 9,-37.09 29.67,-37.09 19.61,0 29.68,11.12 29.68,34.45 v 63.59 h -28.62 v 47.69",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3242.47,3905.38 h 144.15 v -49.29 h -83.73 v -102.81 h 59.88 v -48.76 h -59.88 v -109.16 h 83.73 v -49.29 h -144.15 v 359.31",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3528.13,3915.97 -76.84,-417.59 h -47.17 l 76.84,417.59 h 47.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3612.4,3856.09 v -111.82 h 20.13 c 20.67,0 29.68,10.59 29.68,29.68 v 53 c 0,19.6 -9.01,29.14 -29.68,29.14 z m 0,-145.21 v -164.81 h -60.42 v 359.31 h 87.97 c 60.95,0 83.2,-30.21 83.2,-80.56 v -46.11 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.76,-163.23 h -63.59 l -56.7,164.81",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1436.27,3220.95 v -174.87 h -60.42 v 359.3 h 60.42 v -157.93 l 65.71,157.93 h 59.35 l -69.95,-161.64 71.54,-197.66 h -63.59 l -63.06,174.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1692.25,3129.27 v 192.9 c 0,21.73 -9.54,37.1 -31.27,37.1 -21.2,0 -30.73,-15.37 -30.73,-37.1 v -192.9 c 0,-21.72 9.53,-37.09 30.73,-37.09 21.73,0 31.27,15.37 31.27,37.09 z m -122.42,9.54 v 173.82 c 0,56.18 27.56,96.98 91.15,96.98 64.13,0 91.68,-40.8 91.68,-96.98 v -173.82 c 0,-55.64 -27.55,-96.97 -91.68,-96.97 -63.59,0 -91.15,41.33 -91.15,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1835.35,3271.83 v -225.75 h -50.87 v 359.3 h 59.36 l 65.18,-206.15 v 206.15 h 50.34 v -359.3 h -52.99 l -71.02,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1988,3123.45 v 48.22 h 56.17 v -49.29 c 0,-20.13 9.01,-31.79 29.68,-31.79 19.07,0 27.55,12.71 27.55,31.79 v 13.78 c 0,20.67 -8.48,33.39 -27.02,50.87 l -35.51,35.51 c -34.44,33.92 -50.34,54.59 -50.34,95.92 v 12.18 c 0,44.53 25.97,78.97 84.79,78.97 60.41,0 84.26,-29.68 84.26,-81.61 v -29.15 h -55.12 v 31.27 c 0,20.66 -9.54,30.74 -28.61,30.74 -16.96,0 -28.62,-9.54 -28.62,-29.68 v -7.42 c 0,-20.13 11.13,-31.8 28.62,-48.75 l 38.68,-38.16 c 32.86,-33.38 48.76,-53.52 48.76,-93.26 v -17.49 c 0,-49.29 -26.5,-84.26 -87.97,-84.26 -61.48,0 -85.32,34.44 -85.32,81.61",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2365.87,3405.38 v -271.86 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.86 h 60.41 v -277.69 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.2,0 29.67,14.31 29.67,35.51 v 277.69 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2564.08,3279.25 h -1.58 l -40.81,-233.17 h -28.09 l -45.04,233.17 h -1.06 v -233.17 h -49.82 v 359.3 h 70.49 l 39.21,-202.45 h 0.53 l 34.98,202.45 h 76.31 v -359.3 h -55.12 v 233.17",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2879.43,3405.38 v -271.86 c 0,-55.65 -23.85,-91.68 -85.32,-91.68 -63.59,0 -90.09,36.03 -90.09,91.68 v 271.86 h 60.41 v -277.69 c 0,-21.2 8.48,-35.51 29.68,-35.51 21.2,0 29.67,14.31 29.67,35.51 v 277.69 h 55.65",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2962.12,3271.83 v -225.75 h -50.87 v 359.3 h 59.35 l 65.18,-206.15 v 206.15 h 50.35 v -359.3 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3203.79,3095.35 c 24.91,0 34.45,14.85 34.45,36.58 v 188.12 c 0,21.2 -9.54,36.04 -34.45,36.04 h -25.43 v -260.74 z m 94.86,213.58 v -166.41 c 0,-55.12 -22.78,-96.44 -87.44,-96.44 h -93.27 v 359.3 h 93.27 c 64.66,0 87.44,-40.82 87.44,-96.45",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1436.27,2856.09 v -141.5 h 22.25 c 20.67,0 29.68,10.07 29.68,29.68 v 82.68 c 0,19.59 -9.01,29.14 -29.68,29.14 z m -60.42,49.28 h 89.56 c 60.95,0 83.2,-30.2 83.2,-80.55 v -75.78 c 0,-50.35 -22.25,-81.08 -83.2,-81.08 h -29.14 v -121.88 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1637.66,2856.09 v -111.82 h 20.14 c 20.67,0 29.68,10.6 29.68,29.68 v 53 c 0,19.59 -9.01,29.14 -29.68,29.14 z m 0,-145.21 v -164.8 h -60.41 v 359.29 h 87.97 c 60.95,0 83.2,-30.2 83.2,-80.55 v -46.11 c 0,-38.68 -13.78,-61.46 -48.22,-69.41 l 57.76,-163.22 h -63.59 l -56.71,164.8",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1901.07,2629.27 v 192.9 c 0,21.73 -9.54,37.1 -31.27,37.1 -21.2,0 -30.73,-15.37 -30.73,-37.1 v -192.9 c 0,-21.72 9.53,-37.09 30.73,-37.09 21.73,0 31.27,15.37 31.27,37.09 z m -122.42,9.54 v 173.82 c 0,56.18 27.56,96.98 91.15,96.98 64.12,0 91.68,-40.8 91.68,-96.98 v -173.82 c 0,-55.64 -27.56,-96.97 -91.68,-96.97 -63.59,0 -91.15,41.33 -91.15,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2079.14,2595.35 c 24.91,0 34.45,14.85 34.45,36.58 v 188.12 c 0,21.2 -9.54,36.04 -34.45,36.04 h -25.43 v -260.74 z m 94.86,213.58 v -166.41 c 0,-55.12 -22.78,-96.44 -87.43,-96.44 h -93.28 v 359.29 h 93.28 c 64.65,0 87.43,-40.81 87.43,-96.44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2381.23,2905.37 v -271.85 c 0,-55.65 -23.84,-91.68 -85.31,-91.68 -63.6,0 -90.1,36.03 -90.1,91.68 v 271.85 h 60.42 v -277.68 c 0,-21.2 8.47,-35.51 29.68,-35.51 21.19,0 29.67,14.31 29.67,35.51 v 277.68 h 55.64",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2473.46,2720.95 v -174.87 h -60.41 v 359.29 h 60.41 v -157.92 l 65.72,157.92 h 59.35 l -69.95,-161.63 71.54,-197.66 h -63.59 l -63.07,174.87",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2613.39,2905.37 h 160.57 v -49.28 h -49.81 v -310.01 h -60.94 v 310.01 h -49.82 v 49.28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2799.41,2905.37 h 60.42 v -359.29 h -60.42 v 359.29",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3014.58,2629.27 v 192.9 c 0,21.73 -9.54,37.1 -31.27,37.1 -21.2,0 -30.73,-15.37 -30.73,-37.1 v -192.9 c 0,-21.72 9.53,-37.09 30.73,-37.09 21.73,0 31.27,15.37 31.27,37.09 z m -122.42,9.54 v 173.82 c 0,56.18 27.56,96.98 91.15,96.98 64.12,0 91.68,-40.8 91.68,-96.98 v -173.82 c 0,-55.64 -27.56,-96.97 -91.68,-96.97 -63.59,0 -91.15,41.33 -91.15,96.97",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3157.68,2771.83 v -225.75 h -50.88 v 359.29 h 59.36 l 65.18,-206.14 v 206.14 h 50.35 v -359.29 h -53 l -71.01,225.75",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSdgIconDe12);
export default __webpack_public_path__ + "static/media/SDG-icon-DE-12.018e4864f4051ac51ae81b424f36ca25.svg";
export { ForwardRef as ReactComponent };